import { render, staticRenderFns } from "./Massage.vue?vue&type=template&id=6e14ead1&scoped=true&"
import script from "./Massage.vue?vue&type=script&lang=js&"
export * from "./Massage.vue?vue&type=script&lang=js&"
import style0 from "./Massage.vue?vue&type=style&index=0&id=6e14ead1&prod&lang=scss&scoped=true&"
import style1 from "./Massage.vue?vue&type=style&index=1&id=6e14ead1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e14ead1",
  null
  
)

export default component.exports